module.exports = __webpack_public_path__ + "img/ic_linkedin_original.8a563544.svg";